import type { ReactElement } from "react"
import { useParams } from "react-router"
import { DetailPage } from "~/features/detail/components/DetailPage"
import { useStudyEbook } from "~/features/studyEbook/StudyEbookContext"
import { useStudyDetail } from "../api/useStudyDetail"

/**
 * The Study Detail screen from the OTT frame (node 166:3097), in light mode: the
 * hero over the study's artwork, then every session in the study as a card.
 */
export const StudyDetailPage = (): ReactElement => {
  const { id } = useParams()
  const { view, isLoading, isError } = useStudyDetail(id)
  /**
   * By title, not by id: the graph carries no link between a study and its book,
   * so the pairing is a title-stem heuristic over the ebooks and seats the
   * customer already owns. See `features/studyEbook/studyEbookIndex.ts`.
   */
  const material = useStudyEbook(view?.title)

  return (
    <DetailPage
      view={view}
      isLoading={isLoading}
      isError={isError}
      sessionsTitle="All Sessions"
      emptySessionsMessage="This study has no sessions yet."
      errorMessage="We couldn't load this study right now."
      notFoundMessage="We couldn't find that study in your library."
      material={material}
      qaHook="study-detail"
    />
  )
}
